<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title help-btn">
            {{ params['title'] | translate }} -
            <ng-container *ngFor="let language of languages">
                <span *ngIf="itemLanguage === language['locale']">{{ language['name'] | translate }}</span>
            </ng-container>
        </h4>
    </div>
    <div class="modal-body">
        <edit-modal-header-action-component [params]="params"
                                            (openFormModalAction)="openFormModal.emit()"
                                            (deleteAction)="delete.emit()" (hideModalAction)="hideModal.emit()">
        </edit-modal-header-action-component>
        <ng-template [ngIf]="!formLoading">

            <div class="row mb-2 hidden">
                <mat-form-field class="pull-right col-xs-2 offset-xs-10 filter__language">
                    <mat-select (selectionChange)="changeLanguage($event.value)" [value]="languages[0]['locale']">
                        <mat-option *ngFor="let language of languages;"
                                    [selected]="language['locale'] === itemLanguage"
                                    [value]="language['locale']">
                            {{ language.name | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <form [formGroup]="form" novalidate class="mat-form" #formDirective="ngForm">
                <div class="row">
                    <div #klnicoNameFG class="form-group col-xs-4">
                        <mat-form-field class="ps-content" *ngIf="this.authService.isSuperAdmin">
                            <mat-select (selectionChange)="getSymptomsByDomain($event.value)" [placeholder]="'Select Domain' | translate" formControlName="domain_id">
                                <ng-container *ngFor="let domain of domains">
                                    <mat-option selected [value]="domain['id']">
                                        {{ domain['name_' + itemLanguage] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>

                            <small class="form-text text-danger" [hidden]="form.controls['domain_id'].valid
                                                                            || (form.controls['domain_id'].pristine
                                                                            && !formSubmitted)">
                                {{ 'Require Domain.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                    <div #feelingName class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <input type="text" matInput [placeholder]="('Feeling Name' | translate)"
                                   [formControl]="form.controls['feeling_name_' + itemLanguage]"
                                   (focus)="onInputFocused($event, feelingName)"/>
                            <small class="form-text text-danger" [hidden]="form.controls['feeling_name_' + itemLanguage].valid
                                                                            || (form.controls['feeling_name_' + itemLanguage].pristine
                                                                            && !formSubmitted)">
                                {{ 'Require at least 3 characters.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                    <div #feelingNameOnMap class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <input type="text" matInput [placeholder]="('Feeling Name on map' | translate)"
                                   [formControl]="form.controls['feeling_name_on_map_' + itemLanguage]"
                                   (focus)="onInputFocused($event, feelingNameOnMap)"/>
                            <small class="form-text text-danger" [hidden]="form.controls['feeling_name_on_map_' + itemLanguage].valid
                                                                            || (form.controls['feeling_name_on_map_' + itemLanguage].pristine
                                                                            && !formSubmitted)">
                                {{ 'Require at least 3 characters.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>

                </div>
                <div class="row">
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select (selectionChange)="selectSymptom($event)" [placeholder]="'Symptom' | translate" [formControl]="form.controls['symptom_system_id']">
                                <mat-option [selected] value="0">
                                    {{ 'Add new Symptom' | translate }}
                                </mat-option>
                                <ng-container *ngFor="let symptom of symptomsByDomain">
                                    <mat-option [value]="symptom['symptom_system_id']"
                                                [attr.item-system-id]="symptom['symptom_system_id']"
                                                [selected]="form.controls['symptom_system_id'].value == symptom['symptom_system_id']">
                                        <span *ngIf="symptom['symptom_name_' + itemLanguage] === ''; else symptomNameOpt">
                                            ({{ "Doesn't have Symptom Name in " + itemLanguage | translate}})
                                        </span>
                                        <ng-template #symptomNameOpt>
                                            {{ symptom['symptom_name_' + itemLanguage] }}
                                        </ng-template>
                                        <ng-container *ngIf="symptom['is_locked_in_diagnosis_interview']">
                                            ({{ 'In self rating only' | translate}})
                                        </ng-container>
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div #symptomName class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <input type="text" matInput [placeholder]="('Symptom Name' | translate)"
                                   [formControl]="form.controls['symptom_name_' + itemLanguage]"
                                   (focus)="onInputFocused($event, symptomName)"/>
                            <small class="form-text text-danger" [hidden]="form.controls['symptom_name_' + itemLanguage].valid
                                                                            || (form.controls['symptom_name_' + itemLanguage].pristine
                                                                            && !formSubmitted)">
                                {{ 'Require at least 3 characters.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>

                    <div #symptomNameOnMap class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <input type="text" matInput [placeholder]="('Symptom Name on map' | translate)"
                                   [formControl]="form.controls['symptom_name_on_map_' + itemLanguage]"
                                   (focus)="onInputFocused($event, symptomNameOnMap)"/>
                            <small class="form-text text-danger" [hidden]="form.controls['symptom_name_on_map_' + itemLanguage].valid
                                                                            || (form.controls['symptom_name_on_map_' + itemLanguage].pristine
                                                                            && !formSubmitted)">
                                {{ 'Require at least 3 characters.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-xs-2">
                        <mat-form-field class="ps-content" *ngIf="this.authService.isSuperAdmin">
                            <mat-select [placeholder]="'Standards' | translate" formControlName="standard">
                                <ng-container *ngFor="let standard of standards">
                                    <mat-option class="text-uppercase" [selected]="form.controls['standard'].value == standard['id']" [value]="standard['id']">
                                        {{ standard['name'] | translate }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div #genderSR class="form-group col-xs-2">
                        <mat-form-field class="ps-content" *ngIf="this.authService.isSuperAdmin">
                            <mat-select [placeholder]="'Sex' | translate" formControlName="gender">
                                <ng-container *ngFor="let gender of genders">
                                    <mat-option [selected]="form.controls['gender'].value === gender['value']" [value]="gender['value']">
                                        {{ gender['name'] | translate }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="form-group col-xs-3 offset-xs-2">
                        <mat-form-field class="ps-content">
                            <input type="text"  matInput
                                   placeholder="{{ 'Neutral ID' | translate }}"
                                   [formControl]="form.controls['symptom_neutral_name_system_id']"
                                   [matAutocomplete]="auto"
                                   (keyup)="getNeutralNames($event)"
                            />
                            <mat-autocomplete [classList]="mat-autocomplete" #auto="matAutocomplete"
                                              class="mat-autocomplete"
                                              (optionSelected)="autofillDataRelation($event.option.value)"
                                              [displayWith]="displayFn">
                                <mat-option *ngFor="let option of filteredOptions"
                                            [attr.item-system-id]="option.symptom_neutral_name_system_id"
                                            [value]="option">
                                    {{option}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>

                    </div>
                    <div class="form-group col-xs-3">
                        <mat-form-field class="ps-content">
                            <input type="text" placeholder="{{ 'Neutral Name' | translate }}" matInput
                                   [formControl]="form.controls['symptom_neutral_name_' + itemLanguage]"
                            />
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-xs-2" *ngIf="form.controls.is_indicator">
                        <div class="row">
                            <div class="label col-xs-12">{{ 'Indicator' | translate }}</div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <input type="range" min="0" max="1" step="1" formControlName="is_indicator"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6" [class.label--bold]="form.controls.is_indicator.value === 0">
                                        {{ 'No' | translate }}
                                    </div>
                                    <div class="col-xs-6 text-xs-right" [class.label--bold]="form.controls.is_indicator.value === 1">
                                        {{ 'Yes' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div #indicator class="form-group col-xs-3">
                        <mat-form-field class="ps-content" [class.disabled]="form.controls.is_indicator.value === 0" *ngIf="this.authService.isSuperAdmin">
                            <mat-select [disabled]="form.controls.is_indicator.value === 0" [placeholder]="'Indicator Reference Nr' | translate" formControlName="indicator_reference_id">
                                <ng-container *ngFor="let indicator of indicators">
                                    <mat-option [value]="indicator.system_id">
                                        {{ indicator['system_id'] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-2 offset-xs-1">
                        <mat-form-field class="ps-content" [class.disabled]="form.controls.scientific.value === 1">
                            <input type="text" placeholder="{{ 'Coordinator X' | translate }}" matInput [formControlName]="'coordinate_x_' + this.itemLanguage" />
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-2">
                        <mat-form-field class="ps-content" [class.disabled]="form.controls.scientific.value === 1">
                            <input type="text" placeholder="{{ 'Coordinator Y' | translate }}" matInput [formControlName]="'coordinate_y_' + itemLanguage" />
                        </mat-form-field>
                    </div>

                    <div class="form-group col-xs-2">
                        <mat-form-field class="ps-content" [class.disabled]="form.controls.scientific.value === 1">
                            <mat-select [placeholder]="'Text placement' | translate" [formControlName]="'text_placement_' + this.itemLanguage">
                                <mat-option value="top">{{ 'Top' | translate }}</mat-option>
                                <mat-option value="bottom">{{ 'Bottom' | translate }}</mat-option>
                                <mat-option value="left">{{ 'Left' | translate }}</mat-option>
                                <mat-option value="right">{{ 'Right' | translate }}</mat-option>
                                <mat-option value="top-left">{{ 'Top Left' | translate }}</mat-option>
                                <mat-option value="top-right">{{ 'Top Right' | translate }}</mat-option>
                                <mat-option value="bottom-left">{{ 'Bottom Left' | translate }}</mat-option>
                                <mat-option value="bottom-right">{{ 'Bottom Right' | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-xs-3" *ngIf="form.controls.scientific">
                        <div class="row">
                            <div class="label col-xs-12">{{ 'Scientific' | translate }}</div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <input type="range" min="0" max="1" step="1" formControlName="scientific"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6" [class.label--bold]="form.controls.scientific.value === 0">
                                        {{ 'No' | translate }}
                                    </div>
                                    <div class="col-xs-6 text-xs-right" [class.label--bold]="form.controls.scientific.value === 1">
                                        {{ 'Yes' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-xs-3" *ngIf="form.controls.hide_on_expert_map">
                        <div class="row">
                            <div class="label col-xs-12">{{ 'Hide on expert map' | translate }}</div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <input type="range" min="0" max="1" step="1" formControlName="hide_on_expert_map"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6" [class.label--bold]="form.controls.hide_on_expert_map.value === 0">
                                        {{ 'No' | translate }}
                                    </div>
                                    <div class="col-xs-6 text-xs-right" [class.label--bold]="form.controls.hide_on_expert_map.value === 1">
                                        {{ 'Yes' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-xs-3" *ngIf="form.controls.is_acute">
                        <div class="row">
                            <div class="label col-xs-12">{{ 'Acute Symptom' | translate }}</div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <input (change)="toggleAcute($event, 'is_anam')" type="range" min="0" max="1" step="1" formControlName="is_acute"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6" [class.label--bold]="form.controls.is_acute.value == 0">
                                        {{ 'No' | translate }}
                                    </div>
                                    <div class="col-xs-6 text-xs-right" [class.label--bold]="form.controls.is_acute.value === 1">
                                        {{ 'Yes' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-xs-3" *ngIf="form.controls.is_anam">
                        <div class="row">
                            <div class="label col-xs-12">{{ 'Anamnestic Symptom' | translate }}</div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <input (change)="toggleAcute($event, 'is_acute')" type="range" min="0" max="1" step="1" formControlName="is_anam" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6" [class.label--bold]="form.controls.is_anam.value == 0">
                                        {{ 'No' | translate }}
                                    </div>
                                    <div class="col-xs-6 text-xs-right" [class.label--bold]="form.controls.is_anam.value === 1">
                                        {{ 'Yes' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <mat-form-field #statement
                                    [class.disabled]="form.controls.is_acute.value == 0 ? true : null "
                                    class="form-group col-xs-6">
                        <textarea matInput [formControl]="form.controls['statement_' + itemLanguage]"
                                  placeholder="{{ 'Statement acute for feeling' | translate }}"
                                  (focus)="onInputFocused($event, statement)"
                                  rows="1">
                        </textarea>
                    </mat-form-field>


                    <mat-form-field #question
                                    [class.disabled]="form.controls.is_acute.value == 0 ? true : null "
                                    class="form-group col-xs-6">
                        <textarea matInput [formControl]="form.controls['question_' + itemLanguage]"
                                  placeholder="{{ 'Question acute for feeling' | translate }}"
                                  (focus)="onInputFocused($event, question)"
                                  rows="1">
                        </textarea>
                    </mat-form-field>

                </div>

                <div class="row">
                    <mat-form-field #anamStatement
                                    [class.disabled]="form.controls.is_anam.value == 0 ? true : null "
                                    class="form-group col-xs-6">
                        <textarea matInput [formControl]="form.controls['anam_statement_' + itemLanguage]"
                                  placeholder="{{ 'Statement anamnestic for feeling' | translate }}"
                                  (focus)="onInputFocused($event, anamStatement)"
                                  rows="1">
                        </textarea>
                    </mat-form-field>

                    <mat-form-field #anamQuestion
                                    [class.disabled]="form.controls.is_anam.value == 0 ? true : null"
                                    class="form-group col-xs-6">
                        <textarea matInput [formControl]="form.controls['anam_question_' + itemLanguage]"
                                  placeholder="{{ 'Question anamnestic for feeling' | translate }}"
                                  (focus)="onInputFocused($event, anamQuestion)"
                                  rows="1">
                        </textarea>
                    </mat-form-field>
                </div>

                <div class="row">
                    <mat-form-field #definition class="form-group col-xs-6">
                        <textarea matInput [formControl]="form.controls['definition_' + itemLanguage]"
                                  placeholder="{{ 'Definition of feeling' | translate }}"
                                  (focus)="onInputFocused($event, definition)"
                                  rows="1">
                        </textarea>
                    </mat-form-field>
                </div>

                <div class="row">
                    <div class="col-xs-12 text-xs-right">
                        <button type="button" class="btn btn-secondary" (click)="hideModal.emit()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="generateModelToSubmit()">
                            {{ 'Submit' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>